<template>
  <div>
    <div v-for="contact in contacts">
        <template v-if="contact.contactType.id == 1"><i class="fa fa-phone" aria-hidden="true"></i> <a :href="'tel:'+contact.value">{{contact.value}}</a></template>
        <template v-if="contact.contactType.id == 2"><i class="fa fa-mobile" aria-hidden="true"></i> <a :href="'tel:'+contact.value">{{contact.value}}</a></template>
        <template v-if="contact.contactType.id == 3"><i class="fa fa-fax" aria-hidden="true"></i> {{contact.value}}</template>
        <template v-if="contact.contactType.id == 4"><i class="fa fa-envelope" aria-hidden="true"></i> <a :href="'mailto:'+contact.value">{{contact.value}}</a></template>
        <template v-if="contact.contactType.id == 5"><i class="fa fa-internet-explorer" aria-hidden="true"></i> <a :href="contact.value" target="_blank">{{contact.value}}</a></template>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'index', 'column'],
  computed: {
    contacts () {
      let phones = []
      let emails = []
      let www = []
      let other = []

      this.data.contacts.forEach(contact => {
        switch (contact.contactType.id) {
          case 1:
          case 2:
            phones.push(contact)
            break

          case 4:
            emails.push(contact)
            break

          case 5:
            if (!contact.value.includes('http')) {
              contact.value = 'http://' + contact.value
            }

            www.push(contact)
            break

          default:
            other.push(contact)
        }
      });

      return [...phones, ...emails, ...www, ...other]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/table/ColumnContacts.vue